import axios from 'axios';
import {config} from 'process';
//  import verifAuthenticated from "../Helpers/hooks/useAuth.js";

const api = axios.create({
    // baseURL: "https://192.168.0.101:8444/api", // servidor antigo
    // baseURL: 'https://194.65.149.77:5008/api', // novo servidor produtivo
    baseURL: 'https://crm.liderteam.pt/api',

    // baseURL: 'https://localhost:5001',
    responseType: 'json',
});
export default api;

//api para consultar codigos postais PT
export const apiCP = axios.create({
    baseURL: 'https://json.geoapi.pt',
    responseType: 'json',
});

export async function makeRequest(url, params, signal) {
    verifAuthenticated(signal);
    const token = localStorage.getItem('token');
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'content-type': 'application/json',
        },
        signal,
    };
    return api.post(url, params, config);
}

export async function verifAuthenticated(signal) {
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refresh');

    await api
        .post(
            '/backend/api/login/RefreshToken',
            {
                token: token,
                refreshToken: refreshToken,
            },
            {signal},
        )
        .then(function (response) {
            if (response.data.sucesso == 0) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('refresh', response.data.refToken);
            } else if (response.data.sucesso == 1) {
                // handleLogout();
            }
        })
        .catch(error => {
            if (!axios.isCancel(error)) {
                console.log(error);
            }
        });
}

export function makeRequestPut(url, params) {
    // await verifAuthenticated();
    const token = localStorage.getItem('token');
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'content-type': 'application/json',
        },
    };

    return api.put(url, params, config);
}

export async function makeRequestGet(url, signal) {
    await verifAuthenticated(signal);
    const token = localStorage.getItem('token');
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'content-type': 'application/json',
        },
        signal,
    };

    return api.get(url, config);
}
